import DgModal from "../../../custom/feedback/modal";
import {useDispatch, useSelector} from "react-redux";
import {onChangeVisibleDrawerAdmin} from "../../../redux/actions/layout/interaction/action";
import Add from "./add";
import {useState} from "react";

const AddParent = ()=>{

    const dispatch = useDispatch()
    const {visibleDrawerAdmin} = useSelector(state => state.layoutInteractionReducer)
    const [loading , setLoading] = useState(false)
    return (
        <DgModal visible={visibleDrawerAdmin==="customers"}
                  width={1000}
                  onCancel={() => dispatch(onChangeVisibleDrawerAdmin(undefined))}
                  title={"Tạo mới khách hàng "}
                  bodyStyle={{
                      minHeight: 100,
                      maxHeight: 600,
                      overflowY: "scroll",
                  }}
                  destroyOnClose={true}
                  okText={"Tạo mới"}
                  loading={loading}>
            <Add onLoading={(value)=>setLoading(value)} list={true} />
        </DgModal>
    )
}

export default AddParent
